var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{class:`inspection-report__table-row ${_vm.appendClass || ''}`,attrs:{"colspan":_vm.colspan}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }